import React, { useContext } from 'react';

import { ThemeContext } from 'context/ThemeContext';

import niftyLogo from 'images/nifty-logo.svg';
import niftyLogoLight from 'images/nifty-logo-light.svg';

const NiftyLogo = ({ width = 98 }) => {
    const themeCtx = useContext(ThemeContext);

    return (
        <img className="logo" src={themeCtx.theme === 'dark' ? niftyLogoLight : niftyLogo} width={width} alt="Nifty logo" />
    );
}

export default NiftyLogo;
